import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./kontakt.scss";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
export default function Kontakt() {
  const [contactData, setContactData] = useState<any>({});
  const [errors, setErrors] = useState<any>({});
  const [codChecked, setCodChecked] = useState<any>("");
  const [showErrors, setShowErrors] = useState<any>(false);
  const [cardsData, setCardsData] = useState<any>([]);
  // const [basechecked1, setBaseChecked1] = useState<String>("no");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const clearData = () => {
    setContactData({
      firstname: "",
      email: "",
      telephone: "",
      sname: "",
      firma: "",
      homepage: "",
      reason: "",
      message: "",
      howFind: "",
      codChecked: "",
    });
  };

  const handleChange = (e: any) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });

    setErrors({ ...errors, [e.target.name]: "" });
  };

  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  console.log("basechecked1", contactData?.baseChecked1);
  const handleContactUs = async () => {
    if (
      !contactData.firstname &&
      !contactData.sname &&
      !contactData.firma &&
      !contactData.email &&
      !contactData.telephone &&
      !contactData.homepage &&
      !contactData.reason &&
      !contactData.message &&
      !(contactData?.baseChecked1 === "checked") &&
      !contactData.howFind

      // !codChecked || !codChecked === false
    ) {
      setErrors({
        ...errors,
        firstname: "Bitte überprüfen Sie ihre Eingabe.",
        sname: "Bitte überprüfen Sie ihre Eingabe.",
        firma: "Bitte überprüfen Sie ihre Eingabe.",
        email: "Bitte überprüfen Sie ihre Eingabe.",
        telephone: "Bitte überprüfen Sie ihre Eingabe.",
        homepage: "Bitte überprüfen Sie ihre Eingabe.",
        reason: "Bitte überprüfen Sie ihre Eingabe.",
        // codChecked :"Bitte überprüfen Sie ihre Eingabe.",
        message: "Bitte überprüfen Sie ihre Eingabe.",
        howFind: "Bitte überprüfen Sie ihre Eingabe.",
        baseChecked1: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    }
    // else if (!codChecked || !codChecked === false) {
    //   setErrors({ ...errors, codChecked: "Bitte überprüfen Sie ihre Eingabe." });
    //   setShowErrors(true);
    // }
    else if (!(contactData?.baseChecked1 === "checked")) {
      setErrors({ ...errors, baseChecked1: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.firstname) {
      setErrors({ ...errors, firstname: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.sname) {
      setErrors({ ...errors, sname: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.firma) {
      setErrors({ ...errors, firma: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.email) {
      setErrors({ ...errors, email: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!regex.test(contactData.email)) {
      setErrors({ ...errors, email: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.telephone || contactData.telephone?.length > 14) {
      // toast.error("Please Enter your Last Name");
      setErrors({ ...errors, telephone: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.homepage) {
      setErrors({ ...errors, homepage: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.reason) {
      setErrors({ ...errors, reason: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.howFind) {
      setErrors({ ...errors, howFind: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.message) {
      setErrors({ ...errors, message: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else {
      const body = {
        gender: codChecked,
        fname: contactData.firstname,
        sname: contactData.sname,
        compnay: contactData.firma,
        email: contactData.email,
        phone: contactData.telephone,
        homePage: contactData.homepage,
        reason: contactData.reason,
        howFind: contactData.howFind,
        message: contactData.message,
      };
      console.log("opp", body);

      await axios
        .post(
          "https://api.deutscher.rejoicehub.com/api/v1/contact/create",
          body
        )
        .then((res: any) => {
          console.log(res);
          setContactData({});
          clearData();
          toast.success("Nachricht erfolgreich versendet");
        })
        .catch((err: any) => {
          console.log("err", err);
        });
    }
  };
  {
    console.log("codChecked", !codChecked);
  }

  return (
    <>
      <Toaster />
      <div>
        <div className="kontakt-all-content-and-information-alignment">
          <div className="container">
            <div className="text-grid">
              <div className="text-grid-items">
                <div className="divider"></div>
              </div>
              <div className="text-grid-items">
                <h1>Kontakt</h1>
              </div>
            </div>
            <div className="child-text-style">
              <p>
                Bitte füllen Sie dieses Kontaktformular aus, um innerhalb
                kürzester Zeit eine Rückantwort zu erhalten. Alternativ schicken
                Sie ihre Anfrage an diese E-Mail-Adresse info@did-24.de
              </p>
            </div>
            <div className="main-form-center-alignment">
              <div className="main-form">
                <div className="two-radio-all-buton-center-alignment">
                  <div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        id="test3"
                        name="radio"
                        value={codChecked}
                        checked={codChecked == "woman"}
                        onClick={() => {
                          setCodChecked("woman");
                        }}
                      />
                      <label htmlFor="test3">
                        <span>Frau</span>
                      </label>
                    </div>
                  </div>
                  <div className="right-radio">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        id="test33"
                        name="radio"
                        value={codChecked}
                        checked={codChecked == "man"}
                        onClick={() => {
                          setCodChecked("man");
                        }}
                      />
                      <label htmlFor="test33">
                        <span>Herr</span>
                      </label>
                    </div>
                  </div>
                  &nbsp;
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.codChecked}
                    </span>
                  )}
                </div>
                <div className="two-col-grid">
                  <div className="input">
                    <label>Vorname</label>
                    <input
                      type="text"
                      name="firstname"
                      value={contactData.firstname && contactData.firstname}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.firstname}
                      </span>
                    )}
                  </div>
                  <div className="input">
                    <label>Nachname*</label>
                    <input
                      type="text"
                      name="sname"
                      value={contactData.sname && contactData.sname}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.sname}
                      </span>
                    )}
                  </div>
                </div>
                <div className="full-width">
                  <div className="input">
                    <label>Firma</label>
                    <input
                      type="text"
                      name="firma"
                      value={contactData.firma && contactData.firma}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.firma}
                      </span>
                    )}
                  </div>
                </div>
                <div className="two-col-grid">
                  <div className="input">
                    <label>E-Mail*</label>
                    <input
                      type="text"
                      name="email"
                      value={contactData.email && contactData.email}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.email}
                      </span>
                    )}
                  </div>
                  <div className="input">
                    <label>Telefon</label>
                    <input
                      type="number"
                      name="telephone"
                      value={contactData.telephone && contactData.telephone}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.telephone}
                      </span>
                    )}
                  </div>
                </div>
                <div className="full-width">
                  <div className="input">
                    <label>Homepage</label>
                    <input
                      type="text"
                      name="homepage"
                      value={contactData.homepage && contactData.homepage}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.homepage}
                      </span>
                    )}
                  </div>
                </div>
                <div className="two-col-grid">
                  <div className="input">
                    <label>Kontaktgrund*</label>
                    <input
                      type="text"
                      name="reason"
                      value={contactData.reason && contactData.reason}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.reason}
                      </span>
                    )}
                  </div>
                  <div className="input">
                    <label>Wie haben Sie uns gefunden?</label>
                    <input
                      type="text"
                      name="howFind"
                      value={contactData.howFind && contactData.howFind}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.howFind}
                      </span>
                    )}
                  </div>
                </div>
                <div className="full-width">
                  <div className="input">
                    <label>Ihre Nachricht*</label>
                    <textarea
                      name="message"
                      value={contactData.message && contactData.message}
                      onChange={(e) => handleChange(e)}
                    />
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="kontact-radio-buttong-grid">
                  <div className="kontact-radio-buttong-grid-items">
                    <div className="new-radio-style">
                      <input
                        type="radio"
                        name="baseChecked1"
                        id="baseChecked1"
                        value="checked"
                        onChange={(e: any) => handleChange(e)}
                      />
                      <label htmlFor="baseChecked1"></label>
                    </div>
                  </div>
                  <div className="kontact-radio-buttong-grid-items">
                    <span>
                      Mit dem Absenden meiner Anfrage akzeptiere ich die AGB
                      und, dass ich die <a>Datenschutzerklärung</a> zur Kenntnis
                      genommen habe.
                    </span>
                    {showErrors && (
                      <p
                        style={{
                          fontSize: "10px",
                          color: "red",
                          margin: "5px 0 0 0",
                        }}
                      >
                        {errors.baseChecked1}
                      </p>
                    )}
                  </div>
                </div>
                <div className="last-button-center-alignment">
                  {/* <NavLink to="/immpressum-page"> */}
                  <button onClick={handleContactUs}>Absenden</button>
                  {/* </NavLink> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
